<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{title$ | async}}
    </mat-panel-title>
    <mat-panel-description>
      {{description$ | async}}
    </mat-panel-description>
  </mat-expansion-panel-header>
  @for (child of children; track child) {
    <ng-template #children></ng-template>
  }
</mat-expansion-panel>